const DashboardFeatures = [
  'analytics.fault_summary_dashboard',
  'analytics.asset_usage_summary_dashboard',
  'analytics.vehicle_summary_dashboard',
  'analytics.last_seen_explorer'
];

const DashboardItemID = 'reportsDashboard';

export default function HelpItemsNavService(
  helpReportsItemsService,
  helpAdminItemsService,
  helpAlertsItemsService,
  helpAssetsItemsService,
  helpDevicesItemsService,
  helpMaintenanceItemsService,
  helpMapItemsService,
  helpUsersItemsService,
  $rootScope
) {
  'ngInject';

  var navServices = [];

  for (var i = 0; i < arguments.length; i++) {
    var value = arguments[i];
    if (typeof value.getModule === 'function') {
      navServices.push(value);
    }
  }

  this.isAccessible = function (moduleid) {
    var accessAllowed = false;
    var currentUser = $rootScope.currentUser;
    if (moduleid === DashboardItemID) {
      // Return true if user has at least one feature of dashboard.
      const userFeatures = (currentUser.features || []).map(f => f.path);
      return DashboardFeatures.filter(v => userFeatures.includes(v)).length > 0;
    }

    //Check state access for the account
    if (currentUser.features) {
      for (var i = 0; i < currentUser.features.length; i++) {
        if (moduleid === currentUser.features[i].path) {
          accessAllowed = true;
          break;
        }
      }
    }

    return accessAllowed;
  };

  this.getModules = function () {
    //Compile all of the modules based on the arguments of the nav services injected in here
    var modules = {};
    for (var i = 0; i < navServices.length; i++) {
      var module = navServices[i].getModule();
      if (module.id) {
        modules[module.id] = module;
      }
    }

    return modules;
  };

  var _showingNavService = false;

  this.isShowingHelpSideNav = function () {
    return _showingNavService;
  };

  this.toggleHelpSideNav = function () {
    _showingNavService = !_showingNavService;
  };

  this.hideHelpSideNav = function () {
    _showingNavService = false;
  };

  this.showHelpSideNav = function () {
    _showingNavService = true;
  };
}
